import ReplayIcon from '@mui/icons-material/ReplayRounded';
import { Avatar, Box, CircularProgress, Snackbar, Typography } from '@mui/material';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import useAppVersionWatcher from 'hooks/useVersionCheck';

dayjs.extend(duration);

const VersionChecker = () => {
  const { updateRequired, forceReload, timer, progress } = useAppVersionWatcher();

  return (
    <Snackbar
      open={updateRequired}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      message={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            cursor: 'pointer',
            opacity: 0.75,
          }}
        >
          {progress > 0 && (
            <CircularProgress
              variant="determinate"
              value={progress}
              size={47}
              sx={{ position: 'absolute', left: '13px', zIndex: 22 }}
              color="primary"
            />
          )}

          <Avatar sx={{ bgcolor: 'primary.main', color: 'primary.contrastText' }}>
            <ReplayIcon />
          </Avatar>
          <Box>
            <Typography variant="body1"> Update available</Typography>
            <Typography variant="body2">Click here to update MerQube</Typography>
            {progress > 0 && (
              <Typography variant="caption">
                {`Auto-reloading in ${dayjs.duration(timer, 'seconds').format('mm[:]ss')}s`}
              </Typography>
            )}
          </Box>
        </Box>
      }
      onClick={forceReload}
    />
  );
};

export default VersionChecker;
